import { render } from "./AboutFrame.vue?vue&type=template&id=75dbd479&scoped=true"
import script from "./AboutFrame.vue?vue&type=script&lang=js"
export * from "./AboutFrame.vue?vue&type=script&lang=js"

import "./AboutFrame.vue?vue&type=style&index=0&id=75dbd479&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dbd479"]])

export default __exports__